// // Opera 8.0+
// var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// // Firefox 1.0+
// var isFirefox = typeof InstallTrigger !== 'undefined';

// // Safari 3.0+ "[object HTMLElementConstructor]"
// var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

// // Internet Explorer 6-11
// var isIE = /*@cc_on!@*/false || !!document.documentMode;

// // Edge 20+
// var isEdge = !isIE && !!window.StyleMedia;

// // Chrome 1 - 79
// var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

// // Edge (based on chromium) detection
// var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

// // Blink engine detection
// var isBlink = (isChrome || isOpera) && !!window.CSS;

const isIE = /* @cc_on!@ */ false || !!document.documentMode
const isEdge = !isIE && !!window.StyleMedia

const lfunc = func => list =>
  Array.isArray(list) ? (list.length == null ? list : func(list)) : list

// // keep for MSIE?
// export const flattenOld = ([first, ...rest]) => {
//     if (first == null) {
//         return []
//     } else if (!Array.isArray(first)) {
//         return [first, ...flatten(rest)]
//     } else {
//         return [...flatten(first), ...flatten(rest)]
//     }
// }

const flatten1 = array => array.flat(Infinity)

const flatten2 = arr => {
  const result = []
  const stack = [ ...arr ]
  let first

  while (stack.length > 0) {
    first = stack[0]

    if (Array.isArray(first)) {
      // Replace the nested array with its items
      Array.prototype.splice.apply(stack, [ 0, 1 ].concat(first))
    } else {
      // push onto result, delete the first item
      result.push(stack.splice(0, 1)[0])
    }
  }

  return result
}

export const flatten = arr => (isIE || isEdge ? flatten2(arr) : flatten2(arr))

export const compact = lfunc(list => list.filter(r => r != null))

export const head = lfunc(list => list[0])

export const tail = lfunc(list => list.slice(1))

export const init = lfunc(list => list.slice(0, -1))

export const last = lfunc(list => list.slice(-1))

export const splitAt = (index, list) => {
  if (!Array.isArray(list)) {
    return []
  }

  return [ list.slice(0, index), list.slice(index) ]
}

export const chunk = (list, size) => {
  if (!list) return []

  const chunked = list.slice(0, size)
  if (!chunked.length) {
    return list
  }

  return [ chunked ].concat(chunk(list.slice(size, list.length), size))
}

// export const unique1 = lfunc(list => {
//   let b = [];
//   list.forEach(val => {
//     if (b.indexOf(val) < 0) {
//       b.push(val);
//     }
//   });
//   return b;
// });

const onlyUnique = (value, index, arr) => arr.indexOf(value) === index

export const unique = lfunc(list => list.filter(onlyUnique))

export const first = head

// see https://github.com/hemanth/functional-programming-jargon#sum-type

export const Some = v => ({
  val: v,
  map(f) {
    return Some(f(this.val))
  },
  chain(f) {
    return f(this.val)
  }
})

export const Just = Some

export const None = () => ({
  map() {
    return this
  },
  chain() {
    return this
  }
})

// maybeProp :: (String, {a}) -> Option a
export const maybeProp = (key, obj) =>
  typeof obj[key] === 'undefined' ? None() : Some(obj[key])

// every monad has a bind or flatmap:
// chain == bind == flatmap
// which takes a callback which does something to a value and returnes a monad

//  some == just

// option == maybe
//  maybe is a monad that returns some or nothing

// get == pluck? or pick?

// see https://leanpub.com/javascriptallongesix/read#classes-and-mixins

// const compose = (a, b) => (c) => a(b(c));
export const compose = (a, ...rest) =>
  rest.length === 0 ? a : c => a(compose(...rest)(c))

export const first_compact = compose(first, compact)
export const first_unique = compose(first, unique)

// not sure this works
export const ifElse = condition => onTrue => onFalse => value =>
  (condition(value) ? onTrue : onFalse)(value)

export const ifNull = cond => fn => (...rest) => [ null, false ].indexOf(cond) > -1 ? fn(rest) : null

export const unless = ifNull

export const ifVal = cond => (fn, ...rest) => [ null, false ].contains(cond) ? null : fn(rest)

export const maybe = fn => (...args) => {
  if (args.length === 0) {

  } else {
    for (const arg of args) {
      if (arg == null) return
    }
    return fn.apply(this, args)
  }
}

// experimental:
//
// https://codeburst.io/alternative-to-javascripts-switch-statement-with-a-functional-twist-3f572787ba1c

const matched = x => ({
  on: () => matched(x),
  otherwise: () => x
})

export const match = x => ({
  on: (pred, fn) => (pred(x) ? matched(fn(x)) : match(x)),
  otherwise: fn => fn(x)
})

const done = x => ({
  try: () => done(x),
  last: () => x
  // last: () => {console.log(`here: 2`, x); return x}
})

export const until = (pred, x) => ({
  try: fn => {
    const y = fn(x)
    return pred(y) ? done(y) : until(pred, x)
  },
  last: fn => fn(x)
  // {
  //     console.log(`here 1:`, x)
  //     return fn(x)
  // }
})

// const blocked = x => ({
//     block: true,
//     try: () => done(x),
//     last: () => x
//     // last: () => {console.log(`here: 2`, x); return x}
// })

const blocked = x => ({
  where: () => blocked(x),
  // last: (_, fn) => fn()
  do: (_, fn) => (typeof fn === 'function' ? fn(x) : fn)
  // pass: () => blocked(x),
  // fail: fn => (typeof fn === "function" ? fn(x) : fn)
  // last: () => {console.log(`here: 2`, x); return x}
})

export const guard = x => ({
  // where: fn => (fn(x) === true ? guard(x) : blocked(x)),
  where: fn =>
    typeof fn === 'function'
      ? fn(x) === true
        ? guard(x)
        : blocked(x)
      : fn === true
        ? guard(x)
        : blocked(x),
  do: fn => fn(x)
  // pass: fn => fn(x),
  // pass: fn => (typeof fn === "function" ? fn(x) : fn),

  // fail: () => null

  // last: () => {console.log(`here: 2`, x); return x}
})

// export const guard = (pred, x) => ({
//     try: fn => {
//         const y = fn(x)
//         if (y === true) {
//           block = true;
//         }
//         // return pred(y) ? guarded(y) : guard(pred, x)
//     },

//     last: fn => fn(x)
//     // {
//     //     console.log(`here 1:`, x)
//     //     return fn(x)
//     // }
// })

// until(x => x < 40)
//     .attempt(x => (x += 10))
//     .finally(null, () => console.log("finished:"))
// .attempt()

// const testArgs = fn => rest => {
//     // console.log(`testArgs:`, rest)
//     for (let arg of rest) {
//         if (arg == null) return
//     }
//     return fn(rest)
// }

// const maybe2 = fn => (...args) => {
//     ifElse(t => t.length === 0)
//     ()
//     (testArgs(fn)(args))
//     (args)
// }

// export const maybe = maybe1

export const maybeNot = fn => (...args) => {
  // console.warn(`maybeNot: args`, [... args], args.length)
  if (compact(args).length > 0) {
    return args
  }
  for (const arg of args) {
    // console.log(`maybeNot:`, arg, arg != null)
    if (arg != null) return args
  }
  return fn.apply(this, args)
}

// export const ifNull = (fn) =>
//   function (...args) {
//     if (args.length === 0) {
//       return
//     }
//     else {
//       for (let arg of args) {
//         if (arg != null) return;
//       }
//       return fn.apply(this, args)
//     }
//   }

export const either = (right, left) => {
  const r = right()
  return r == null ? left() : r
}

export const map = arr => fn => arr.map(fn)

export const mapWith = fn => array => map(array, fn)

export const deepMapWith = fn =>
  function innerdeepMapWith(tree) {
    return Array.prototype.map.call(tree, element =>
      Array.isArray(element) ? innerdeepMapWith(element) : fn(element))
  }

export const flip = fn =>
  function (first, second) {
    if (arguments.length === 2) {
      return fn(second, first)
    }
    return function (second) {
      return fn(second, first)
    }
  }

// const get = (object, attr) => object[attr];
// pluck?

const _getWith = attr => object => maybe(object => object[attr])(object)

export const getWith = (...attrs) => object => {
  // let r;
  for (const a of attrs) {
    // console.log(`attr:`, a)
    object = _getWith(a)(object)
    if (object == null) return
  }
  return object
}

const _pipe = (f1, f2) => value => maybe(f2)(maybe(f1)(value))

export const pipe = (funcs = []) => value => {
  funcs.reduce((acc, f) => _pipe(acc, f)(value))
  return value
}

export const pluckWith = compose(mapWith, getWith)

// const test = (...args) => `test succeeded: ${args}`

// let t = unless(true)(test)(`what?`)
// console.log(`test: ${t}`)>>>>>>> .r8226
